export const environment = {
  production: false,
  title: 'X-TRADE Test',

  api: {
    auth: '/api/authentication',
    public: '/api/public',
    property: '/api/property',
    ndg: '/api/ndg',
    survey: '/api/survey',
    report: '/api/report'
  }
};
